export const TIPI_VARIABILE_PER_IMPOSTAZIONI = {
  STRING: 'string',
  INT: 'int',
  DOUBLE: 'double',
  BOOL: 'bool',
  JSON: 'json'
}